/**
 * @module app.shared
 */
import { ValuesOf } from 'app/shared/lib/types';

export const VerificationMethods = Object.freeze(['email', 'text'] as const);
export type VerifyBy = ValuesOf<typeof VerificationMethods>;
export type IIdentification = {
    emailAddress?: string;
    phoneNumber?: string;
};
export const IdentificationMapping = new Map<VerifyBy, keyof IIdentification>([
    ['email', 'emailAddress'],
    ['text', 'phoneNumber']
]);

export interface IAssistanceRequest {
    application: {
        code: string;
    };
    verifyBy: VerifyBy;
    targetLink: {
        title: string;
        baseUrl: string;
        href: string;
    };
}

export interface IForgotLoginRequest extends IAssistanceRequest {
    identification: IIdentification;
}

export interface IResetPasswordRequest extends IAssistanceRequest {
    credentials: {
        loginName: string
    };
}
